import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const EditIcon = ({ color, ...rest }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill={color ?? token.colorBorder}
        fillRule="evenodd"
        d="M3 17.252v3.75h3.75l11.06-11.06-3.75-3.75L3 17.252zm17.71-10.21c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      />
    </svg>
  );
};

export default EditIcon;
